import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: ["'Nunito'", "'Roboto'", 'sans-serif'].join(', '),
  },
  palette: {
    primary: {
      main: '#0c3f61',
    },
    secondary: {
      main: '#e4332a',
    },
  },
});

export default theme;
